import {
    SvgIcon,
    useTheme,
} from '@mui/material';
import React from 'react';

export const UiLogo: React.FC<{
    height?: number;
    width?: number;
    color?: string;
    className?: string;
    'data-cy'?: string;
}> = ({
    height = 42, width = 114, color, className, 'data-cy': dataCy,
}) => {
    const theme = useTheme();

    return (
        <SvgIcon
            viewBox={`0 0 ${width} ${height}`}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={{
                width,
                height,
            }}
            className={className}
            data-cy={dataCy}
        >
            <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd">
                <g
                    id="ui_path_Logo_SMALL_rgb_Blue_digital_147x50"
                    fill={color || theme.palette.semantic.colorLogo}
                    fillRule="nonzero"
                >
                    <path
                        d="M0,0 L42,0 L42,42 L0,42 L0,0 Z M37.632,37.632 L37.632,4.368 L4.368,4.368 L4.368,37.632 L37.632,37.632 L37.632,37.632 Z M8.148,10.836 L8.148,23.52 C8.148,29.316 11.34,32.76 16.716,32.76 C22.26,32.76 25.452,29.316 25.452,23.52 L25.452,10.836 L21.084,10.836 L21.084,23.52 C21.084,26.796 19.656,28.644 16.8,28.644 C13.776,28.644 12.432,26.712 12.432,23.52 L12.432,10.836 L8.148,10.836 Z M31.08,13.44 C32.592,13.44 33.768,12.348 33.768,10.836 C33.768,9.24 32.676,8.148 31.08,8.148 C29.568,8.148 28.392,9.24 28.392,10.836 C28.392,12.348 29.568,13.44 31.08,13.44 Z M28.896,15.456 L28.896,32.508 L33.264,32.508 L33.264,15.456 L28.896,15.456 Z M54.936,25.536 C59.64,25.536 62.748,22.764 62.748,18.144 C62.748,13.692 59.724,10.836 54.936,10.836 L46.704,10.836 L46.704,32.592 L51.072,32.592 L51.072,25.62 L54.936,25.62 L54.936,25.536 Z M54.432,22.092 L50.988,22.092 L50.988,14.364 L54.432,14.364 C56.952,14.364 58.296,15.792 58.296,18.144 C58.296,20.664 56.952,22.092 54.432,22.092 Z M64.176,24.024 C64.176,29.148 67.452,32.76 72.072,32.76 C74.844,32.76 76.608,31.752 77.616,30.156 L77.616,32.592 L81.984,32.592 L81.984,15.456 L77.616,15.456 L77.616,18.144 C76.524,16.38 74.76,15.288 72.072,15.288 C67.368,15.288 64.176,18.984 64.176,24.024 Z M77.616,24.024 C77.616,26.964 75.768,28.896 73.08,28.896 C70.14,28.896 68.628,26.796 68.628,24.024 C68.628,21 70.308,19.068 73.08,19.068 C75.852,19.068 77.616,21.084 77.616,24.024 Z M92.904,28.812 C91.224,28.812 90.804,28.056 90.804,26.544 L90.804,19.152 L94.584,19.152 L94.584,15.456 L90.804,15.456 L90.804,10.752 L86.436,10.752 L86.436,15.456 L84.42,15.456 L84.42,19.152 L86.436,19.152 L86.436,26.544 C86.436,30.576 88.2,32.508 92.4,32.508 L94.668,32.508 L94.668,28.812 L92.904,28.812 Z M101.388,17.892 L101.388,9.828 L97.02,9.828 L97.02,32.592 L101.388,32.592 L101.388,23.52 C101.388,20.58 102.9,18.816 105.504,18.816 C108.024,18.816 109.368,20.496 109.368,23.1 L109.368,32.508 L113.736,32.508 L113.736,22.68 C113.736,18.228 110.544,15.288 106.512,15.288 C103.992,15.288 102.396,16.212 101.388,17.892 Z"
                        id="Shape"
                    />
                </g>
            </g>
            {' '}
        </SvgIcon>
    );
};
